import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TModalsState } from "../../../api/store/commonSlice";
import { useOverviewContext } from "../context/overview.context";
import {
  dbTimeToJsTime,
  formattedDateTimeBasedOnTimezone,
} from "../../../utils/dateTime";
import { useAccountTimezone } from "../../../hooks/timezone";

type TTimeFilterDropdownProps = {
  onSelection?: () => void;
};

const TimeFilterDropdown: FC<TTimeFilterDropdownProps> = ({ onSelection }) => {
  const dispatch = useDispatch();
  const { tzForDateFns } = useAccountTimezone();
  const modalsState: TModalsState = useSelector(
    (state: any) => state.commonReducer.modals
  );
  const {
    dashboardList,
    selectedDashboard,
    setSelectedDashboard,
    allTimeFilters,
    timeFilter,
    setTimeFilter,
  } = useOverviewContext();
  return (
    <div className="absolute top-full left-0 bg-white rounded-lg flex flex-col px-3 py-3 mt-2 w-72 shadow-lg border border-black/10 z-popup">
      <ul className="flex flex-col gap-3 text-sm text-heading-gray666 max-h-[calc(100vh-190px)] overflow-auto">
        {allTimeFilters.map((value, index) => (
          <li key={index} className="flex">
            <button
              type="button"
              className={`flex-grow flex flex-col text-left p-3 rounded-lg ${value?.slug === timeFilter ? "text-accent-blue-bright" : "hover:bg-accent-blue-paleO66"}`}
              onClick={() => {
                setTimeFilter(value?.slug);
                onSelection?.();
              }}
            >
              <span className="font-bold">{value?.title}</span>
              <span className="text-xs">
                {formattedDateTimeBasedOnTimezone(
                  dbTimeToJsTime(value?.timeRange[0]),
                  tzForDateFns,
                  "MM/dd/yyyy"
                )}{" "}
                -{" "}
                {formattedDateTimeBasedOnTimezone(
                  dbTimeToJsTime(value?.timeRange[1]),
                  tzForDateFns,
                  "MM/dd/yyyy"
                )}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
export default TimeFilterDropdown;
